(function () {
	'use strict';

	angular.module('ngTextTruncate', ['pascalprecht.translate'])

			.directive('ngTextTruncate', ['$compile', 'ValidationServices', 'CharBasedTruncation', 'WordBasedTruncation',
				function ($compile, ValidationServices, CharBasedTruncation, WordBasedTruncation) {
					return {
						restrict: 'A',
						require: ['ngModel'],
						scope: {
							model: '=ngModel',
							charsThreshould: '@ngTtCharsThreshold',
							wordsThreshould: '@ngTtWordsThreshold',
							customMoreLabel: '@ngTtMoreLabel',
							customLessLabel: '@ngTtLessLabel'
						},
						link: function ($scope, $element, $attrs, $reqs) {

							$scope.toggleShow = function ($event) {
								$event.stopPropagation();
								$scope.open = !$scope.open;
							};

							$scope.useToggling = $attrs.ngTtNoToggling === undefined;

							$scope.open = false;

							ValidationServices.failIfWrongThreshouldConfig($scope.charsThreshould, $scope.wordsThreshould);

							var CHARS_THRESHOLD = parseInt($scope.charsThreshould);
							var WORDS_THRESHOLD = parseInt($scope.wordsThreshould);

							$scope.$watch('model', function () {
								$element.empty();

								if (CHARS_THRESHOLD) {
									if ($scope.model && CharBasedTruncation.truncationApplies($scope, CHARS_THRESHOLD)) {
										CharBasedTruncation.applyTruncation(CHARS_THRESHOLD, $scope, $element);

									} else {
										$element.append($scope.model);
									}

								} else {

									if ($scope.model && WordBasedTruncation.truncationApplies($scope, WORDS_THRESHOLD)) {
										WordBasedTruncation.applyTruncation(WORDS_THRESHOLD, $scope, $element);

									} else {
										$element.append($scope.model);
									}

								}
							});
						}
					};
				}
			])

			.factory('ValidationServices', function () {
				return {
					failIfWrongThreshouldConfig: function (firstThreshould, secondThreshould) {
						if ((!firstThreshould && !secondThreshould) || (firstThreshould && secondThreshould)) {
							throw 'You must specify one, and only one, type of threshould (chars or words)';
						}
					}
				};
			})

			.factory('CharBasedTruncation', ['$compile', function ($compile) {
					return {
						truncationApplies: function ($scope, threshould) {
							return $scope.model.length > threshould;
						},
						applyTruncation: function (threshould, $scope, $element) {
							if ($scope.useToggling) {
								var el = angular.element('<span>' +
										$scope.model.substr(0, threshould) +
										'<span ng-show="!open">...</span>' +
										'<span class="btn-link ngTruncateToggleText" ' +
										'ng-click="toggleShow($event)" ng-show="!open">' +
										' ' + ($scope.customMoreLabel ? $scope.customMoreLabel : 'More') +
										'</span>' +
										'<span ng-show="open">' +
										$scope.model.substring(threshould) +
										'<span class="btn-link ngTruncateToggleText"' +
										'ng-click="toggleShow($event)">' +
										' ' + ($scope.customLessLabel ? $scope.customLessLabel : 'Less') +
										'</span>' +
										'</span>' +
										'</span>');
								$compile(el)($scope);
								$element.append(el);

							} else {
								$element.append($scope.model.substr(0, threshould) + '...');

							}
						}
					};
				}])

			.factory('WordBasedTruncation', ['$compile', '$translate', function ($compile, $translate) {
					return {
						truncationApplies: function ($scope, threshould) {
							return $scope.model.split(' ').length > threshould;
						},
						applyTruncation: function (threshould, $scope, $element) {
							var splitText = $scope.model.split(' ');
							if ($scope.useToggling) {
								var el = angular.element('<span>' +
										splitText.slice(0, threshould).join(' ') +
										'<span ng-show="!open">...</span>' +
										' <span class="btn-link ngTruncateToggleText" ' +
										'ng-click="toggleShow($event)"' +
										'ng-show="!open">' +
										$translate.instant(($scope.customMoreLabel ? $scope.customMoreLabel : 'Plus')) +
										'</span>' +
										'<span ng-show="open">' +
										splitText.slice(threshould, splitText.length).join(' ') +
										' <span class="btn-link ngTruncateToggleText"' +
										'ng-click="toggleShow($event)">' +
										$translate.instant(($scope.customLessLabel ? $scope.customLessLabel : 'Moins')) +
										'</span>' +
										'</span>' +
										'</span>');
								$compile(el)($scope);
								$element.append(el);

							} else {
								$element.append(splitText.slice(0, threshould).join(' ') + '...');
							}
						}
					};
				}]);
}());
